import React from 'react';
import { Chip, useMediaQuery, useTheme } from '@mui/material';
import { EventStatusColors } from '@pv/common/colors';
import { HourglassBottom, MarkEmailUnread } from '@mui/icons-material';
import { ExternalLink, Send, Check, FileText, X } from 'react-feather';
import { Confetti } from '../../components/icons';
export const InquiryStatusChip = ({
  hasResponse,
  status = 'pending',
}: {
  hasResponse: boolean;
  status?: string;
}) => {
  const theme = useTheme();
  const smMedia = useMediaQuery(theme.breakpoints.down('md'));
  const chipConfig = getChipConfig(status, hasResponse);
  const sx = {
    backgroundColor: chipConfig.backgroundColor,
    color: chipConfig.textColor,
    padding: '8px',
  };

  if (smMedia) {
    return (
      <Chip
        icon={chipConfig.icon}
        sx={{
          ...sx,
          '.MuiChip-label': {
            display: 'none',
          },
          '.MuiChip-icon': {
            margin: 0,
          },
        }}
      />
    );
  }

  return (
    <Chip
      label={chipConfig.label}
      icon={chipConfig.icon}
      sx={{
        ...sx,
        fontWeight: 'bold',
        width: '100%',
        maxWidth: '180px',
      }}
    />
  );
};

const getChipConfig = (venueEventStatus: string, hasResponse: boolean) => {
  switch (venueEventStatus) {
    case 'pending':
      return guestEventStatus.unsent;
    case 'lead':
    case 'qualified':
      if (hasResponse) {
        return guestEventStatus.venue_responded;
      }
      return guestEventStatus.awaiting_reply;
    case 'proposal_sent':
      return guestEventStatus.proposal_received;
    case 'balance_due':
    case 'confirmed':
      return guestEventStatus.confirmed;
    case 'completed':
      return guestEventStatus.completed;
    case 'lost':
      return guestEventStatus.cancelled;
    default:
      return guestEventStatus.sent;
  }
};
const guestEventStatus = {
  unsent: {
    label: 'Incomplete',
    backgroundColor: EventStatusColors.pending,
    textColor: 'black',
    icon: <ExternalLink size={16} color="black" />,
  },
  awaiting_reply: {
    label: 'Awaiting Reply',
    backgroundColor: EventStatusColors.pending,
    textColor: 'black',
    icon: <HourglassBottom />,
  },
  venue_responded: {
    label: 'Venue Responded',
    backgroundColor: EventStatusColors.confirmed,
    textColor: 'black',
    icon: <MarkEmailUnread />,
  },
  sent: {
    label: 'Inquiry Sent',
    backgroundColor: EventStatusColors.pending,
    textColor: 'black',
    icon: <Send size={16} color="black" />,
  },
  confirmed: {
    label: 'Confirmed',
    backgroundColor: EventStatusColors.confirmed,
    textColor: 'black',
    icon: <Check size={16} color="black" />,
  },
  completed: {
    label: 'Completed',
    backgroundColor: EventStatusColors.completed_ytd,
    textColor: 'white',
    icon: <Confetti size={16} color="white" />,
  },
  proposal_received: {
    label: 'Proposal Received',
    backgroundColor: EventStatusColors.balance_due,
    textColor: 'black',
    icon: <FileText size={16} color="black" />,
  },
  cancelled: {
    label: 'Cancelled',
    backgroundColor: EventStatusColors.lost,
    textColor: 'black',
    icon: <X size={16} color="black" />,
  },
};
